import { _ as __rest } from '../../../tslib.es6-C8rd5pYo.mjs';
import { css, jsx } from '@emotion/react';
import { useState, useContext, useCallback, useMemo } from 'react';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import '../../../theme/ZinniaStylesReset.es.js';
import { Link } from '../Link/Link.es.js';
import PageNavigationContext from './PageNavigationContext.es.js';

const Styles = {
  link: css`
    display: block !important;
    text-decoration: none !important;

    & {
      &:focus {
        border-radius: 3px !important;
        color: ${Colors.blue} !important;
        outline: 2px solid ${Colors.blue} !important;
        outline-offset: -1px !important;
      }
    }
  `,
  row: css`
    width: 100%;

    & {
      &:focus {
        border-radius: 3px !important;
        color: ${Colors.blue} !important;
        outline: 2px solid ${Colors.blue} !important;
        outline-offset: -1px !important;
      }
    }
  `
};
function PageNavigationRow({ content: Content, isSelectable = true, item, nestedList: Children, onSelect }) {
  const [hover, setHover] = useState(false);
  const context = useContext(PageNavigationContext);
  const { id, setId } = context;
  const selected = item.id === id;
  const handleOnSelect = useCallback((event) => {
    if (onSelect) {
      const itemWithNoChildren = __rest(item, ["children"]);
      onSelect(itemWithNoChildren, event);
    }
    if (isSelectable) {
      setId(item.id);
    }
  }, [isSelectable, item, onSelect, setId]);
  const linkContent = useMemo(() => item.href ? jsx(
    Link,
    { css: Styles.link, href: item.href, onBlur: () => setHover(false), onClick: (e) => {
      handleOnSelect(e);
      e.stopPropagation();
    }, onKeyDown: (e) => {
      if (e.key === "Enter") {
        handleOnSelect(e);
        e.stopPropagation();
      } else if (e.key === " ") {
        e.preventDefault();
      }
    }, onFocus: () => setHover(true), onMouseEnter: () => setHover(true), onMouseLeave: () => setHover(false) },
    jsx(Content, { hover, selected })
  ) : jsx(
    "div",
    { "aria-label": item.title, css: Styles.row, "data-zds": true, onBlur: () => setHover(false), onClick: (e) => handleOnSelect(e), onFocus: () => setHover(true), onKeyDown: (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        handleOnSelect(e);
      }
    }, onMouseEnter: () => setHover(true), onMouseLeave: () => setHover(false), role: "button", tabIndex: 0 },
    jsx(Content, { hover, selected })
  ), [handleOnSelect, hover, item.href, item.title, selected]);
  return jsx(
    "li",
    { "data-zds": true },
    linkContent,
    Children && jsx(Children, null)
  );
}

export { PageNavigationRow as default };
//# sourceMappingURL=PageNavigationRow.es.js.map
